<template>
  <div>
    <el-select
      v-model="value"
      placeholder="Porcentaje"
      size="mini"
      @change="OnPercentageChange"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "PercentageSelector",
  props: {
    initialValue: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      options: [
        {
          value: 0,
          label: "0%"
        },
        {
          value: 25,
          label: "25%"
        },
        {
          value: 50,
          label: "50%"
        },
        {
          value: 75,
          label: "75%"
        },
        {
          value: 100,
          label: "100%"
        }
      ],
      value: ""
    };
  },
  mounted() {
    this.value = this.initialValue;
  },
  updated() {
    this.value = this.initialValue;
  },
  methods: {
    OnPercentageChange(val) {
      this.$emit("PercentageChanged", val);
    }
  },
  watch: {
    initialValue(initialValue) {
      this.value = initialValue;
    }
  }
};
</script>

<style lang="scss" scoped></style>
